$(document).ready(function () {
   'use strict';

   var $container = $('.js-quiz-form');

   if ($container.length) {

       var $selects = $container.find('.js-select2');
       var $middleNameInput = $container.find('.js-middle-name');
       var $noMiddleNameCheckbox = $container.find('.js-no-middle-name');
       var $dateOfBirthInput = $container.find('.js-date-of-birth');
       var $phoneInput = $container.find('.js-phone');

       var $countrySelect = $container.find('.js-country-select');
       var regionRequiredValue = $countrySelect.data('region-required-value');

       var $regionSelect = $container.find('.js-region-select');
       var $regionHolder = $regionSelect.closest('.js-region-holder');

       var $educationHolder = $container.find('.js-education-holder');
       var $educationCheckboxes = $container.find('.js-education');
       var $educationNoneCheckbox = $container.find('.js-education-none');

       var $jobHolder = $container.find('.js-job-holder');
       var $jobSelect = $jobHolder.find('.js-job-select');
       var $jobInput = $jobHolder.find('.js-another-job');

       var anotherJobCodes = $jobSelect.data('other-value');
       var anotherJobLabels = $jobSelect.data('other-labels');

       $phoneInput.inputmask('+[99999999999999]', {
           placeholder: '',
       });

       $dateOfBirthInput.inputmask({
           alias: 'datetime',
           inputFormat: 'dd.mm.yyyy',
           placeholder: '__.__.____'
       });

       $noMiddleNameCheckbox.on('change', function () {
          var $target = $(this);
          var isChecked = $target.prop('checked');
          var $holder = $target.closest('.form-row');
          var $errorBlock = $holder.find('.form-group.has-error');
          var $helpBlock = $holder.find('.help-block');

          $errorBlock.removeClass('has-error');
          $helpBlock.text('');

          if (isChecked) {
              $middleNameInput.prop('disabled', true);
          } else {
              $middleNameInput.prop('disabled', false);
          }
       });

       $countrySelect.on('change', function () {
          var $target = $(this);
          var value = Number($target.val());

         if (value !== regionRequiredValue) {
            $regionHolder.addClass('hidden');
         } else {
             $regionHolder.removeClass('hidden');
         }

       });

       $educationHolder.on('change', 'input', function () {
           var $target = $(this);
           var isNoEducation = ($target.get(0) === $educationNoneCheckbox.get(0)) && $target.prop('checked');
           var checkedCount = $educationCheckboxes.filter(function () {
               return $(this).prop('checked');
           }).length;

           if (checkedCount === 0) {
               $educationCheckboxes.each(function () {
                  $(this).prop('disabled', false);
               });

               return;
           }

           if (isNoEducation) {
               $educationCheckboxes.each(function (index, el) {
                   if (!$(el).hasClass('js-education-none')) {
                       $(el).prop('disabled', true);
                   }
               });
           } else {
               $educationNoneCheckbox.prop('disabled', true);
           }
       });

       $selects.each(function () {
          var $target = $(this);


          $target.select2({
              'dropdownParent': $target.closest('.form')
          });

           console.log($target.data('select2'));
       });

       $jobSelect.on('change', function () {
           if (anotherJobCodes.indexOf(Number($(this).val())) !== -1) {
               $jobInput.show();

               var label = anotherJobLabels[$(this).val()];
               $jobInput.find('.control-label').text(label);
           } else {
               $jobInput.hide();
           }
       });

       $container.on('change', '.js-optional-select', function() {
           var $select = $(this);
           var $holder = $select.closest('.js-optional-select-holder');
           var $otherInput = $holder.find('.js-another-value-holder');

           var value = Number($select.val());
           var anotherCodes = $select.data('other-value');
           var anotherLabels = $select.data('other-labels');

           if (anotherCodes.indexOf(value) !== -1) {
               $otherInput.show();

               var label = anotherLabels[$(this).val()];
               $otherInput.find('.control-label').text(label);
           } else {
               $otherInput.hide();
           }
       });
   }
});
